













import Vue from 'vue';
import {
  Prop, Component,
} from 'vue-property-decorator';
import DateField from '@/components/FormBuilder/fields/DateField.vue';

@Component({
  components: {
    DateField,
  },
})
export default class DateFilter extends Vue {
  @Prop({
    required: true,
  }) label!: string

  @Prop({
    required: false,
    default: '',
  }) filterType!: string

  @Prop({
    required: false,
    default: '',
  }) initialValue!: string

  @Prop({
    type: Function,
    required: false,
    default: (name: string, time: string) => time,
  }) filterMethod!: Function

  @Prop({
    default: null,
  })
  allowedDates!: void;

  filterValue = '';

  async beforeMount() {
    this.filterValue = this.initialValue;
    this.$bus.$on('clear-filters', () => {
      this.filterValue = '';
      this.$emit('set-date-value', { entityName: this.filterType, dateValue: '' });
    });
  }

  mounted() {
    if (this.filterValue !== '' && typeof this.filterValue !== 'undefined') {
      this.$emit(
        'set-time',
        {
          entityName: this.filterType,
          filterValue: this.filterMethod(this.filterType, this.filterValue),
        },
      );
    }
  }

  beforeDestroy() {
    this.$bus.$off('clear-filters');
  }

  setTime(entityName: string, dateValue: string, filterValue: string) {
    if (!entityName) {
      this.$emit('set-time', filterValue);
      this.$emit('on-search');
      return;
    }
    const filter = {
      entityName,
      filterValue: dateValue ? filterValue : null,
    };
    this.$emit('set-date-value', { entityName, dateValue });
    this.$emit('set-time', filter);
    this.$emit('on-search');
  }
}
